import { IsValidDomain } from './Router';
import { DOMAIN_NAMES } from './Domain';

export const PERMISSION_LOGIN = 'login';
export const PERMISSION_DRIVE_ACCESS = 'drive_access';
export const PERMISSION_DRIVE_UPLOAD = 'drive_upload';
export const PERMISSION_FFDA_DASHBOARD = 'ffda_dashboard_rw';
export const PERMISSION_FFDA_SUPPLIES = 'ffda_supplies_rw';
export const PERMISSION_FFDA_1099 = 'ffda_1099_rw';
export const PERMISSION_FFDA_BOOKS = 'ffda_books_rw';
export const PERMISSION_FFDA_REPORTS = 'ffda_reports';

export const PERMISSIONS_AVAILABLE = [
    PERMISSION_LOGIN,
    PERMISSION_DRIVE_ACCESS,
];

export class PermissionManager {
    static isAuthenticated(session, profile) {
        return Boolean(session && profile);
    }

    static isNotAuthenticated(session, profile) {
        return Boolean(!PermissionManager.isAuthenticated(session, profile));
    }

    static hasVirtualAccount(session, profile) {
        if (!PermissionManager.isAuthenticated(session, profile)) {
            return false;
        }

        return Boolean(session.currentVirtualAccount);
    }

    static hasNoVirtualAccount(session, profile) {
        if (!PermissionManager.isAuthenticated(session, profile)) {
            return false;
        }

        return Boolean(!session.currentVirtualAccount);
    }

    static isFederated(session, profile) {
        if (!PermissionManager.hasVirtualAccount(session, profile)) {
            return false;
        }

        return Boolean(
            IsValidDomain(DOMAIN_NAMES.FIDUCIAL_FEDERATED, profile, session)
        );
    }

    static isNotFederated(session, profile) {
        if (!PermissionManager.hasVirtualAccount(session, profile)) {
            return false;
        }

        return Boolean(
            IsValidDomain(DOMAIN_NAMES.FIDUCIAL, profile, session) ||
                IsValidDomain(DOMAIN_NAMES.FIDUCIAL_JADE, profile, session)
        );
    }

    static isBusinessOwner(session, profile) {
        if (!PermissionManager.hasVirtualAccount(session, profile)) {
            return false;
        }

        return Boolean(profile.isBusinessOwner);
    }

    static isNotFederatedBusinessOwner(session, profile) {
        return Boolean(
            PermissionManager.isNotFederated(session, profile) &&
                PermissionManager.isBusinessOwner(session, profile)
        );
    }

    static isFederatedWithDashboardPermission(session, profile) {
        if (!PermissionManager.isFederated(session, profile)) {
            return false;
        }

        return Boolean(profile._permissions?.ffda_dashboard_rw);
    }

    static hasVirtualAccountWithDriveAccess(session, profile) {
        if (!PermissionManager.hasVirtualAccount(session, profile)) {
            return false;
        }

        return Boolean(profile._permissions?.drive_access);
    }

    static hasVirtualAccountWithDriveUpload(session, profile) {
        if (!PermissionManager.hasVirtualAccount(session, profile)) {
            return false;
        }

        return Boolean(profile._permissions?.drive_upload);
    }

    static hasEntityFolderAccess(session) {
        if (!session) {
            return false;
        }

        const { modules } = session;

        if (
            modules &&
            modules.drive &&
            modules.drive.hasClientFolder === true
        ) {
            return true;
        }

        return false;
    }

    static hasPermissions(profile, permissionsRequired) {
        if (!permissionsRequired) return false;

        for (const perm of permissionsRequired) {
            if (
                !profile ||
                !profile._permissions ||
                !profile._permissions[perm]
            ) {
                return false;
            }
        }

        return true;
    }
}

export default PermissionManager;
